<!--
  @Input  General input field in Pentelion App
  WARNING: Change to Input.svelte should be reflected in Output.svelte as well.
-->

<script>
  import {fieldLabels, fieldHints, protoSkills} from "../core.js";
  import Ability from "./Ability.svelte";

	let {field, value = $bindable(), defaultval = "", type = 'text', separate = false, disabled = false, unlabeled = false,
			 onchange: onchangeFunc = null, class: className = '', style: styleDefs = '',
			 help = null} = $props()		// help: documentation topic if it differs from field
	let label = $derived(fieldLabels[field] ?? field)
  let hint  = $derived(fieldHints[field] ?? null)

  function change_value(e) {
    value = type.match(/^(number|range)$/) ? +e.target.value : e.target.value;
		if (onchangeFunc)
			onchangeFunc(e)
		}

  function process_keydown(e) {
		if (e.key === 'Enter') {
			e.preventDefault()
			e.target.blur()
		}
  }
</script>


<!-------------------------------- HTML -------------------------------------->

{#if separate && !unlabeled}
	<label for={field} {separate} title={hint} data-help={help}>
		{#if field in protoSkills}
			<Ability ability={protoSkills[field]} />
		{:else}
			{label}
		{/if}
	</label>
{/if}
<div class="inputBox {className}" style="{styleDefs}">
	<input type={type} id={field} data-help={help} bind:value={value} placeholder={defaultval} {disabled} style="{styleDefs}"
	       onchange={change_value} onkeydown={process_keydown} onfocus={(e) => e.target.select()} />
	{#if !separate && !unlabeled && label}
    <label for={field} type={type} title={hint} data-help={help}>{label}</label>
	{/if}
</div>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	label
    display: block
    color: colors.$grey-85

	label[type=number]
    width: 4ch
    text-align: center
    color: #aaa

	label[separate]
    line-height: 175%

	.inputBox label
    font-size: 75%
    padding-left: 5px

	input
    width: 100%
    border: none
    border-bottom: 2px solid colors.$grey-50
    background-color: colors.$grey-15
    text-align: inherit

	input[type=number]
    width: 100%
    text-align: center
    justify-self: center
    /* max-width: 200px */

	input[disabled]
    background: unset
    color: white

	input:focus
    border-color: colors.$grey-85
    outline: none
    transition: border-color 0.2s ease-out
    will-change: border-color
</style>

<!-- from: https://github.com/countnazgul/svelte-input/tree/master -->